<template>
  <div class="UserCardForm">
    <div class="icon-wrapper">
      <i class="icon-hombre"></i>
    </div>
    <div class="info">
      <h2 class="title">{{ title }}</h2>
      <p class="date"></p>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  title: String,
  date: String
})
</script>

<style lang="scss" scoped>
.UserCardForm {
  display: flex;
  align-items: center;
  margin: $spacing-l 0;

  .icon-wrapper {
    border-radius: $b-radius-100;
    padding: $spacing-10;
    margin-right: $spacing-15;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $color-primary-light;
    width: $size-36;
    height: $size-36;
  }

  .info {
    display: flex;
    align-items: center;
    color: $color-neutral;

    .title {
      margin: 0;
      font-size: $font-size-l;
      font-weight: $font-weight-400;
      line-height: $line-height-140p;
    }
  }

  i {
    font-size: $font-size-20;

    &::before{
      color: var(--vt-c-white);
    }
  }
}
</style>
